import store from 'store2'

import { JWT_TOKEN_NAME } from '../../constants/auth-key'

const Logout = () => {
  store.remove(JWT_TOKEN_NAME)
  window.location.href = '/login?logout=true&page=logout'
  return null
}

export default Logout
